import React, { useContext } from "react";
import Select from "react-select";
import * as urlService from "../../view/urlService";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import { deepCopy, sortByAlphabet } from "../../utils";

function ScheduleSelectMsbField({ msbList = [], selectedType, setMsbId, msbId }) {
    const menuPortalTarget = typeof document !== 'undefined' ? document.body : null;
    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const onChange = (selectedOption) => {
        const id = selectedOption?.value ?? -1;
        setMsbId(id);
        setConfig({ ...config, msbId: id });

        if (Number(id) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('msb')
            });
            return;
        }

        const msb = msbList.find(item => item.id === Number(id));

        if (msb) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('msb', msb.name)
            });
        }
    };

    const msbRenderList = deepCopy(msbList)
        .sort((a, b) => sortByAlphabet(a.name, b.name));

    const options = msbRenderList.map(msb => ({
        value: msb.id,
        label: msb.name
    }));
    const selectedOption = options.find((option) => String(option.value) === String(msbId)) || null;

    return (
        <div className="modal-v2-schedule-field-group">
            <label htmlFor="schedule-msb">Management Security Baseline (MSB) <span className="modal-v2-required-mark">*</span></label>
            <Select
                inputId="schedule-msb"
                className="oct_selectsearch-v2"
                classNamePrefix="oct-selectsearchsub-v2"
                value={selectedOption}
                onChange={onChange}
                options={options}
                isSearchable
                isDisabled={Number(selectedType) <= 0}
                menuPlacement="auto"
                menuPosition="fixed"
                menuPortalTarget={menuPortalTarget}
                maxMenuHeight={240}
                minMenuHeight={240}
                placeholder="Select baseline"
                noOptionsMessage={() => Number(selectedType) <= 0 ? "Select a device type first" : "No MSBs available"}
            />
        </div>
    );
}

export default ScheduleSelectMsbField;
